import { render, staticRenderFns } from "./DraggableFixedTable.vue?vue&type=template&id=a1144ca0&scoped=true"
import script from "./DraggableFixedTable.vue?vue&type=script&lang=ts"
export * from "./DraggableFixedTable.vue?vue&type=script&lang=ts"
import style0 from "./DraggableFixedTable.vue?vue&type=style&index=0&id=a1144ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1144ca0",
  null
  
)

export default component.exports